import React from "react";

/**
 * Tiny Zelle indicator when enrollment email/phone and display name are saved.
 */
export default function ZelleBadge({
  zelleUsername,
  zelleRecipientName,
  className = "",
  title = "Zelle",
}) {
  const has =
    zelleUsername &&
    String(zelleUsername).trim() &&
    zelleRecipientName &&
    String(zelleRecipientName).trim();
  if (!has) return null;

  return (
    <span className={`as-zelle-badge ${className}`.trim()} title={title} aria-hidden="true">
      Z
    </span>
  );
}
